import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useBrand } from './BrandProvider';

const Logo = ({ clickable = true, size = 'large' }) => {
  const navigate = useNavigate();
  const brand = useBrand();

  const handleClick = () => {
    if (clickable) {
      navigate('/');
    }
  };

  // Définir la taille selon le contexte
  const sizeClasses = {
    small: 'h-12',    // 48px pour footer
    medium: 'h-16',   // 64px
    large: 'h-24'     // 96px pour header (par défaut)
  };

  // Taille du badge "Fabriqué en France"
  const badgeSizeClasses = {
    small: 'h-12',     // 48px pour footer
    medium: 'h-14',    // 56px
    large: 'h-16'      // 64px pour header (100% plus grand)
  };

  return (
    <div 
      className={`flex flex-col items-end gap-0 ${clickable ? 'cursor-pointer' : ''}`}
      onClick={handleClick}
    >
      {/* Logo principal - dynamique selon la marque */}
      <img 
        src={brand.logo} 
        alt={brand.name} 
        className={`${sizeClasses[size]} w-auto object-contain`}
      />
      {/* Badge Fabriqué en France */}
      <img 
        src="https://customer-assets.emergentagent.com/job_ecommerce-store-28/artifacts/iqri7494_fab_ligne_droit_cartouche_rvb-1024x448%20%281%29.jpg" 
        alt="Fabriqué en France" 
        className={`${badgeSizeClasses[size]} w-auto object-contain`}
      />
    </div>
  );
};

export default Logo;
